module.exports = __webpack_public_path__ + "media/images/illustrations/tape_multi_small-67e30ecf0a36d0d318936af602aa17bb.svg";